var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row text-center my-3 action-button pt-4" }, [
        _c(
          "label",
          {
            staticClass:
              "col-lg-6 col-md-8 col-xs-12 col-12 radio radio-before pb-3",
          },
          [
            _c("span", { staticClass: "radio__input" }, [
              _c("input", {
                attrs: { type: "radio", dusk: "juridical-person" },
                domProps: { checked: _vm.profile.billing_type == "pj" },
                on: {
                  click: function ($event) {
                    _vm.$emit("resetErrors")
                    _vm.profile.billing_type = "pj"
                  },
                },
              }),
              _c("span", { staticClass: "radio__control" }),
            ]),
            _c("span", { staticClass: "radio__label" }, [
              _vm._v(_vm._s(_vm.$t("juridical_person"))),
            ]),
          ]
        ),
        _c(
          "label",
          {
            staticClass:
              "col-lg-6 col-md-8 col-xs-12 col-12 radio radio-before pb-3",
          },
          [
            _c("span", { staticClass: "radio__input" }, [
              _c("input", {
                attrs: { type: "radio", dusk: "person" },
                domProps: { checked: _vm.profile.billing_type == "pf" },
                on: {
                  click: function ($event) {
                    _vm.$emit("resetErrors")
                    _vm.profile.billing_type = "pf"
                  },
                },
              }),
              _c("span", { staticClass: "radio__control" }),
            ]),
            _c("span", { staticClass: "radio__label" }, [
              _vm._v(_vm._s(_vm.$t("individual_person"))),
            ]),
          ]
        ),
      ]),
      _vm.profile.billing_type == "pj"
        ? [
            _vm.countries
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "input-text",
                      attrs: { for: "taraInmatriculare2" },
                    },
                    [_vm._v(_vm._s(_vm.$t("label_country")) + "*")]
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.profile.country,
                          expression: "profile.country",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { id: "taraInmatriculare2" },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.profile,
                              "country",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function ($event) {
                            return _vm.validate()
                          },
                        ],
                      },
                    },
                    _vm._l(_vm.countries, function (c) {
                      return _c(
                        "option",
                        { key: c.id, domProps: { value: c.id } },
                        [_vm._v(_vm._s(c.country))]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "d-flex align-items-end p-0",
                class: _vm.isDesktop() ? "pr-4" : "",
              },
              [
                _c("div", { staticClass: "mr-3" }, [
                  _c("div", { staticClass: "form-group m-0" }, [
                    _c(
                      "label",
                      { staticClass: "input-text", attrs: { for: "cui" } },
                      [_vm._v(_vm._s(_vm.$t("label_cui")) + "*")]
                    ),
                    _vm.errorMsgs.fiscal_code
                      ? _c("span", { staticClass: "invalid-feedback" }, [
                          _vm._v(" " + _vm._s(_vm.errorMsgs.fiscal_code) + " "),
                        ])
                      : _vm._e(),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.profile.fiscal_code,
                          expression: "profile.fiscal_code",
                        },
                      ],
                      staticClass: "form-control p-4",
                      class: { "has-error": _vm.errorMsgs.fiscal_code },
                      attrs: { dusk: "cui", type: "text" },
                      domProps: { value: _vm.profile.fiscal_code },
                      on: {
                        blur: function ($event) {
                          return _vm.getTermene()
                        },
                        focus: function ($event) {
                          return _vm.hideVerifiedStatus()
                        },
                        keyup: function ($event) {
                          return _vm.validateROCui(_vm.profile)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.profile,
                            "fiscal_code",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm.profile.country == 1 && !_vm.manualProfileCompletion
                  ? _c(
                      "div",
                      {
                        staticClass: "text-right",
                        class: _vm.isDesktop() ? "ml-1" : "",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "main-btn",
                            attrs: {
                              dusk: "verify-cui",
                              disabled: !_vm.profile.fiscal_code,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getTermene()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("btn_verify")))]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _c("div", [
              _vm.recaptchaError != null
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-danger text-center mt-3",
                      attrs: { id: "recaptcha-error" },
                    },
                    [_vm._v(" " + _vm._s(_vm.recaptchaError) + " ")]
                  )
                : _vm._e(),
              _c("div", { attrs: { id: "recaptcha-container" } }),
            ]),
            _c(
              "div",
              { staticClass: "d-flex mt-2" },
              [
                !_vm.manualProfileCompletion && _vm.profile.country == 1
                  ? [
                      _c("div", { staticClass: "icon warning-icon mr-2" }),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("auto_query_company_data"))),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm.profile.country == 1 &&
            _vm.profile.fiscal_code &&
            _vm.showVerifiedStatus &&
            !_vm.loadingTermene
              ? [
                  _vm.profile.validated_cui && !_vm.manualProfileCompletion
                    ? _c(
                        "div",
                        { staticClass: "text-success mb-4 input-text" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("verified_company_data")) + " "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "text-warning mb-4 input-text" },
                        [
                          _vm.manualProfileCompletion
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "unverified_company_data_with_manual_completion"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            : [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("unverified_company_data")) +
                                    " "
                                ),
                              ],
                        ],
                        2
                      ),
                ]
              : _vm._e(),
            _vm.loadingTermene
              ? _c(
                  "div",
                  { staticClass: "text-center mt-4" },
                  [
                    _c("van-loading", {
                      attrs: { type: "spinner", color: "#1989fa" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            [
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: { "mt-3": _vm.manualProfileCompletion },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "input-text autocompleted",
                      attrs: { for: "company" },
                    },
                    [_vm._v(_vm._s(_vm.$t("label_company_name")) + "*")]
                  ),
                  _vm.errorMsgs.company
                    ? _c("span", { staticClass: "invalid-feedback" }, [
                        _vm._v(" " + _vm._s(_vm.errorMsgs.company) + " "),
                      ])
                    : _vm._e(),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.company,
                        expression: "profile.company",
                      },
                    ],
                    staticClass: "form-control p-4 w-100",
                    class: { "has-error": _vm.errorMsgs.company },
                    attrs: {
                      type: "text",
                      id: "company",
                      disabled:
                        !_vm.manualProfileCompletion &&
                        _vm.profile.country == 1,
                    },
                    domProps: { value: _vm.profile.company },
                    on: {
                      change: function ($event) {
                        return _vm.validate()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.profile, "company", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "form-group wi-75" }, [
                _c(
                  "label",
                  {
                    staticClass: "input-text autocompleted w-100",
                    attrs: { for: "regcom" },
                  },
                  [_vm._v(_vm._s(_vm.$t("label_reg_com")) + "*")]
                ),
                _vm.errorMsgs.j_code
                  ? _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errorMsgs.j_code) + " "),
                    ])
                  : _vm._e(),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.profile.j_code,
                      expression: "profile.j_code",
                    },
                  ],
                  staticClass: "form-control p-4",
                  class: { "has-error": _vm.errorMsgs.j_code },
                  attrs: {
                    type: "text",
                    id: "regcom",
                    disabled:
                      !_vm.manualProfileCompletion &&
                      _vm.profile.country == 1 &&
                      !_vm.requiredManualInput("j_code"),
                  },
                  domProps: { value: _vm.profile.j_code },
                  on: {
                    change: function ($event) {
                      return _vm.validate()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.profile, "j_code", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "form-group wi-75" }, [
                _c(
                  "label",
                  {
                    staticClass: "input-text autocompleted w-100",
                    attrs: { for: "city1" },
                  },
                  [_vm._v(_vm._s(_vm.$t("label_locality")) + "*")]
                ),
                _vm.errorMsgs.city
                  ? _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errorMsgs.city) + " "),
                    ])
                  : _vm._e(),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.profile.city,
                      expression: "profile.city",
                    },
                  ],
                  staticClass: "form-control p-4",
                  class: { "has-error": _vm.errorMsgs.city },
                  attrs: {
                    type: "text",
                    id: "city1",
                    disabled:
                      !_vm.manualProfileCompletion &&
                      _vm.profile.country == 1 &&
                      !_vm.requiredManualInput("city"),
                  },
                  domProps: { value: _vm.profile.city },
                  on: {
                    change: function ($event) {
                      return _vm.validate()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.profile, "city", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "input-text autocompleted",
                    attrs: { for: "address1" },
                  },
                  [_vm._v(_vm._s(_vm.$t("label_address")) + "*")]
                ),
                _vm.errorMsgs.address
                  ? _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errorMsgs.address) + " "),
                    ])
                  : _vm._e(),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.profile.address,
                      expression: "profile.address",
                    },
                  ],
                  staticClass: "form-control p-4 w-100",
                  class: { "has-error": _vm.errorMsgs.address },
                  attrs: {
                    type: "text",
                    id: "address1",
                    disabled:
                      !_vm.manualProfileCompletion &&
                      _vm.profile.country == 1 &&
                      !_vm.requiredManualInput("address"),
                  },
                  domProps: { value: _vm.profile.address },
                  on: {
                    change: function ($event) {
                      return _vm.validate()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.profile, "address", $event.target.value)
                    },
                  },
                }),
              ]),
            ],
          ]
        : _vm._e(),
      _vm.profile.billing_type == "pf"
        ? [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                { staticClass: "input-text", attrs: { for: "last_name" } },
                [_vm._v(_vm._s(_vm.$t("label_last_name")) + "*")]
              ),
              _vm.errorMsgs.last_name
                ? _c("span", { staticClass: "invalid-feedback" }, [
                    _vm._v(" " + _vm._s(_vm.errorMsgs.last_name) + " "),
                  ])
                : _vm._e(),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profile.last_name,
                    expression: "profile.last_name",
                  },
                ],
                staticClass: "form-control p-4",
                class: { "has-error": _vm.errorMsgs.last_name },
                attrs: { id: "last_name", type: "text" },
                domProps: { value: _vm.profile.last_name },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.profile, "last_name", $event.target.value)
                    },
                    _vm.validate,
                  ],
                },
              }),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                { staticClass: "input-text", attrs: { for: "first_name" } },
                [_vm._v(_vm._s(_vm.$t("label_first_name")) + "*")]
              ),
              _vm.errorMsgs.first_name
                ? _c("span", { staticClass: "invalid-feedback" }, [
                    _vm._v(" " + _vm._s(_vm.errorMsgs.first_name) + " "),
                  ])
                : _vm._e(),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profile.first_name,
                    expression: "profile.first_name",
                  },
                ],
                staticClass: "form-control p-4",
                class: { "has-error": _vm.errorMsgs.first_name },
                attrs: { id: "first_name", type: "text" },
                domProps: { value: _vm.profile.first_name },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.profile, "first_name", $event.target.value)
                    },
                    _vm.validate,
                  ],
                },
              }),
            ]),
            _vm.countries
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "input-text",
                      attrs: { for: "taraInmatriculare" },
                    },
                    [_vm._v(_vm._s(_vm.$t("label_country")) + "*")]
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.profile.country,
                          expression: "profile.country",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "has-error": _vm.errorMsgs.country },
                      attrs: { id: "taraInmatriculare" },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.profile,
                              "country",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.validate,
                        ],
                      },
                    },
                    _vm._l(_vm.countries, function (c) {
                      return _c("option", { domProps: { value: c.id } }, [
                        _vm._v(_vm._s(c.country)),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm.counties && _vm.profile.country == 1
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { staticClass: "input-text", attrs: { for: "county" } },
                    [_vm._v(_vm._s(_vm.$t("label_county")) + "*")]
                  ),
                  _vm.errorMsgs.county
                    ? _c("span", { staticClass: "invalid-feedback" }, [
                        _vm._v(" " + _vm._s(_vm.errorMsgs.county) + " "),
                      ])
                    : _vm._e(),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.profile.county,
                          expression: "profile.county",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "has-error": _vm.errorMsgs.county },
                      attrs: { dusk: "country", id: "county" },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.profile,
                              "county",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.validate,
                        ],
                      },
                    },
                    _vm._l(_vm.counties, function (c) {
                      return _c("option", { domProps: { value: c.id } }, [
                        _vm._v(_vm._s(c.name)),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                { staticClass: "input-text", attrs: { for: "city" } },
                [_vm._v(_vm._s(_vm.$t("label_city")) + "*")]
              ),
              _vm.errorMsgs.city
                ? _c("span", { staticClass: "invalid-feedback" }, [
                    _vm._v(" " + _vm._s(_vm.errorMsgs.city) + " "),
                  ])
                : _vm._e(),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profile.city,
                    expression: "profile.city",
                  },
                ],
                staticClass: "form-control p-4",
                class: { "has-error": _vm.errorMsgs.city },
                attrs: { id: "city", type: "text" },
                domProps: { value: _vm.profile.city },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.profile, "city", $event.target.value)
                    },
                    _vm.validate,
                  ],
                },
              }),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                { staticClass: "input-text", attrs: { for: "address" } },
                [_vm._v(_vm._s(_vm.$t("label_address")))]
              ),
              _vm.errorMsgs.address
                ? _c("span", { staticClass: "invalid-feedback" }, [
                    _vm._v(" " + _vm._s(_vm.errorMsgs.address) + " "),
                  ])
                : _vm._e(),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profile.address,
                    expression: "profile.address",
                  },
                ],
                staticClass: "form-control p-4",
                class: { "has-error": _vm.errorMsgs.address },
                attrs: { dusk: "address", type: "text" },
                domProps: { value: _vm.profile.address },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.profile, "address", $event.target.value)
                    },
                    _vm.validate,
                  ],
                },
              }),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }